export default __webpack_public_path__ + "static/media/img_services07.c3d4f8e8.png";